import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CitafuturaComponent } from './components/citafutura/citafutura.component';

const routes: Routes = [
  { path: 'citafutura', component: CitafuturaComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CitafuturaRoutingModule { }
